module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp5-7ebbaab03401539a3cfe93ef71a51a1c.jpg";